import type { Types } from '@fiverr-private/theme';
import type { SizeType } from './types';
import { conversational } from './styles.ve.css';

const PROPS_BY_SIZE: {
    [key in SizeType]: {
        height: Types.BoxType['height'];
        fontSize: Types.BoxType['fontSize'];
        lineHeight: Types.BoxType['lineHeight'];
        paddingX: Types.BoxType['paddingX'];
        paddingY: Types.BoxType['paddingY'];
        gap: Types.BoxType['gap'];
        paddingRightWithCloseIcon: Types.BoxType['paddingRight'];
    };
} = {
    xs: {
        height: 24,
        fontSize: 'b_xs',
        lineHeight: 'b_xs',
        paddingX: '3',
        paddingY: '1',
        gap: '1',
        paddingRightWithCloseIcon: '0',
    },
    sm: {
        height: 32,
        fontSize: 'b_sm',
        lineHeight: 'b_sm',
        paddingX: '3',
        paddingY: '1',
        gap: '1',
        paddingRightWithCloseIcon: '1',
    },
    md: {
        height: 36,
        fontSize: 'b_md',
        lineHeight: 'b_md',
        paddingX: '4',
        paddingY: '1.5',
        gap: '1.5',
        paddingRightWithCloseIcon: '1.5',
    },
};

export const getTagStyles = ({ size, isInteractive, variant, hasCloseIcon, shape, isDark }): Types.BoxType => {
    const { paddingRightWithCloseIcon, ...rest } = PROPS_BY_SIZE[size];
    const defaultOutlineBackground = isDark ? 'white_10' : 'white';
    const defaultFilledBackground = isDark ? 'white_10' : 'grey_300';

    return {
        ...rest,
        color: isDark ? 'grey_400' : 'grey_1200',
        outlineColor: {
            focusVisible: isDark ? 'grey_400' : 'grey_1200',
        },
        outlineStyle: { focusVisible: 'solid' },
        outlineWidth: {
            focusVisible: 'md',
        },
        outlineOffset: {
            focusVisible: 'sm',
        },
        decoration: isInteractive ? { hover: 'none' } : undefined,
        boxSizing: 'borderBox',
        ...(shape === 'default'
            ? {
                  borderRadius: 'circle',
              }
            : { className: conversational }),
        display: 'flex',
        alignItems: 'center',
        ...(hasCloseIcon && {
            paddingRight: paddingRightWithCloseIcon,
        }),
        width: 'fit-content',
        fontWeight: 'normal',
        userSelect: 'none',
        ...(variant === 'filled' && {
            backgroundColor: isInteractive
                ? {
                      default: defaultFilledBackground,
                      hover: isDark ? 'white_20' : 'grey_400',
                      active: isDark ? 'white_20' : 'grey_500',
                  }
                : defaultFilledBackground,
        }),
        ...(variant === 'outline' && {
            borderWidth: 'sm',
            borderColor: 'border',
            borderStyle: 'solid',
            backgroundColor: isInteractive
                ? {
                      default: defaultOutlineBackground,
                      hover: isDark ? 'white_20' : 'grey_200',
                      active: isDark ? 'white_20' : 'grey_500',
                  }
                : defaultOutlineBackground,
        }),
        flexShrink: 0,
        maxWidth: '100%',
    };
};
